import { BaseApi } from './base.api.js';

export class TeamApi extends BaseApi {
    constructor(client) {
        super(client, '/team');
    }

    async getAssignments(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/assignments`, { params });
        return response.data;
    }

    async createAssignment(id, body) {
        const response = await this.client.post(`${this.basePath}/${id}/assignments`, body);
        return response.data;
    }

    async updateAssignment(id, assignmentId, body) {
        const response = await this.client.patch(`${this.basePath}/${id}/assignments/${assignmentId}`, body);
        return response.data;
    }

    async deleteAssignment(id, assignmentId) {
        const response = await this.client.delete(`${this.basePath}/${id}/assignments/${assignmentId}`);
        return response.data;
    }

    async getDutyProfiles(id, params = {}) {
        const response = await this.client.get(`${this.basePath}/${id}/duty-profiles`, { params });
        return response.data;
    }

    async createDutyProfile(id, body) {
        const response = await this.client.post(`${this.basePath}/${id}/duty-profiles`, body);
        return response.data;
    }

    async updateDutyProfile(id, profileId, body) {
        const response = await this.client.patch(`${this.basePath}/${id}/duty-profiles/${profileId}`, body);
        return response.data;
    }

    async deleteDutyProfile(id, profileId) {
        const response = await this.client.delete(`${this.basePath}/${id}/duty-profiles/${profileId}`);
        return response.data;
    }
}
